import React, { useState } from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '../ui/dialog';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../ui/select';

const INITIAL = {
  userId: '',
  venueId: '',
  clockInAt: '',
  clockOutAt: '',
  notes: '',
};

export default function CreateShiftDialog({ staffOptions, venueOptions, onSubmit, submitting }) {
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState(INITIAL);

  const handleCreate = async (event) => {
    event.preventDefault();
    await onSubmit({ ...formData, source: 'manager' });
    setFormData(INITIAL);
    setOpen(false);
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button className="btn-rtb-secondary">Create Shift</Button>
      </DialogTrigger>
      <DialogContent className="bg-[#1E1E1E] border-[#3F3F46] text-white max-w-xl">
        <DialogHeader>
          <DialogTitle className="font-heading uppercase">Create Manual Shift</DialogTitle>
          <DialogDescription className="text-[#A1A1AA]">
            Use this when staff forgot to clock in/out and the shift must be backfilled.
          </DialogDescription>
        </DialogHeader>

        <form onSubmit={handleCreate} className="space-y-4">
          <div>
            <Label className="mb-2 block">Staff *</Label>
            <Select
              value={formData.userId}
              onValueChange={(value) => setFormData((prev) => ({ ...prev, userId: value }))}
              required
            >
              <SelectTrigger className="input-rtb">
                <SelectValue placeholder="Select staff member" />
              </SelectTrigger>
              <SelectContent className="bg-[#1E1E1E] border-[#3F3F46] text-white">
                {staffOptions.map((staff) => (
                  <SelectItem key={staff.id} value={staff.id}>{staff.name}</SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>

          <div>
            <Label className="mb-2 block">Venue *</Label>
            <Select
              value={formData.venueId}
              onValueChange={(value) => setFormData((prev) => ({ ...prev, venueId: value }))}
              required
            >
              <SelectTrigger className="input-rtb">
                <SelectValue placeholder="Select venue" />
              </SelectTrigger>
              <SelectContent className="bg-[#1E1E1E] border-[#3F3F46] text-white">
                {venueOptions.map((venue) => (
                  <SelectItem key={venue.id} value={venue.id}>{venue.name}</SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>

          <div className="grid gap-4 md:grid-cols-2">
            <div>
              <Label className="mb-2 block">Clock In *</Label>
              <Input
                type="datetime-local"
                value={formData.clockInAt}
                onChange={(e) => setFormData((prev) => ({ ...prev, clockInAt: e.target.value }))}
                className="input-rtb"
                required
              />
            </div>
            <div>
              <Label className="mb-2 block">Clock Out</Label>
              <Input
                type="datetime-local"
                value={formData.clockOutAt}
                onChange={(e) => setFormData((prev) => ({ ...prev, clockOutAt: e.target.value }))}
                className="input-rtb"
              />
            </div>
          </div>

          <div>
            <Label className="mb-2 block">Notes</Label>
            <Textarea
              value={formData.notes}
              onChange={(e) => setFormData((prev) => ({ ...prev, notes: e.target.value }))}
              className="input-rtb min-h-[80px]"
            />
          </div>

          <DialogFooter>
            <Button type="button" variant="secondary" onClick={() => setOpen(false)}>
              Cancel
            </Button>
            <Button type="submit" disabled={submitting || !formData.userId || !formData.venueId || !formData.clockInAt}>
              {submitting ? 'Creating...' : 'Create Shift'}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
